import { Logger, LoggerContext, useEnvironment, TimerContext } from "@amzn/xb-hooks";
import { useContext } from "react";
import { LiveComponentSourceProps, LiveContext, LiveInterceptor } from "../live-component";
import { createConsoleLogger, createRumLogger } from "../loggerFactories";
import { useTimerHookProvider } from "../timing";

/**
 *  Update the Logger and Timer context to be specific to this LiveComponent
 */
export const xpsLoggerProviderInterceptor: LiveInterceptor = (
  { experienceProviderName: xpsName, componentName },
  Response
) => {
  const ResponseWithLogger = (props: LiveComponentSourceProps) => {
    const { isDev } = useEnvironment();
    const { xbAppName } = useContext(LiveContext);
    const logger: Logger = isDev()
      ? createConsoleLogger({ xpsName, componentName })
      : createRumLogger({ xbAppName, xpsName, componentName });

    return (
      <>
        <LoggerContext.Provider value={logger}>
          <TimerContext.Provider value={useTimerHookProvider}>
            <Response {...props} />
          </TimerContext.Provider>
        </LoggerContext.Provider>
      </>
    );
  };

  return ResponseWithLogger;
};
